import { apiCall } from "./index";

// 🔹 Get sub branches by branch
export const getSubBranchesByBranch = (branchId) => {
    return apiCall(`/sub-branches/by-branch/${branchId}`);
};

// 🔹 Get shifts by sub branch
export const getShiftsBySubBranch = (subBranchId) => {
    return apiCall(`/sub-branches/${subBranchId}/shifts`);
};
